

import { types } from './brandingImageActions';
import { type Action } from '../../types';

export type BrandingImageState = {
  imageUrl?: string,
  isLoading: boolean,
  hasError: boolean,
};

const initialState = {
  imageUrl: undefined,
  isLoading: true,
  hasError: false,
};

export default function reducer(
  state: BrandingImageState = initialState,
  action: Action<{ brandingImageUrl: string }>,
): BrandingImageState {
  switch (action.type) {
    case types.LOAD:
      return { ...state, isLoading: true, hasError: false };
    case types.LOAD_SUCCESS:
      return {
        ...state,
        imageUrl: action?.response?.brandingImageUrl || undefined,
        isLoading: false,
      };
    case types.LOAD_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
      };
    default:
      return state;
  }
}
